import { useEffect, useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import DialogBox from "components/shared/modal/DialogBox";
import CustomTab from "components/shared/Tab/CustomTab";
import ReviewTab from "./ReviewTab";
import type { ReviewDetails } from "../types";
import Loader from "components/shared/loader/loader";
import BookingDetails from "screens/individual-booking/components/BookingDetails";
import { useBookingById } from "../hooks/useBookingById";

interface ReviewModalProps {
  open: boolean;
  handleClose: () => void;
  review: ReviewDetails;
  merchantName?: string;
}

const ReviewModal = ({
  open,
  handleClose,
  review,
  merchantName,
}: ReviewModalProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const { data: bookingData, isFetching, error } = useBookingById(
    review?.bookingId,
    activeTab === 1
  );


  useEffect(() => {
    setActiveTab(0);
  }, [open]);


  const tabs = [
    {
      label: "Review Details",
      content: (
        <ReviewTab selectedReview={review} merchantName={merchantName} />
      ),
    },
    {
      label: "Booking Details",
      content: isFetching ? (
        <Loader />
      ) : error ? (
        <Box sx={{ p: 2 }}>
          <Typography color="error">
            Failed to load booking details. {error}
          </Typography>
        </Box>
      ) : bookingData ? (
        <BookingDetails data={bookingData} />
      ) : (
        <Box sx={{ p: 2 }}>
          <Typography color="textSecondary">No booking data available</Typography>
        </Box>
      ),
    },
  ];

  return (
    <DialogBox open={open} onClose={handleClose}>
      <Box p={4}>
        {/* Header with title and close button */}
        <Box display={"flex"} justifyContent={"flex-start"}>
          <Typography variant="h6" fontWeight="600" color="black">
            Review Modal
          </Typography>
          <IconButton
            sx={{ color: "black", marginLeft: "auto" }}
            aria-label="close"
            size="small"
            onClick={handleClose}
          >
            <Tooltip title="Close">
              <Close />
            </Tooltip>
          </IconButton>
        </Box>

        {/* Tabbed content */}
        <CustomTab
          tabs={tabs}
          activeTab={activeTab}
          onChange={(index) => setActiveTab(index)}
          sx={{
            mt: 2,
            borderBottom: "1px solid #e0e0e0",
            maxHeight: "500px",
          }}
        />
      </Box>
    </DialogBox>
  );
};

export default ReviewModal;
